import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Dropdown from "react-bootstrap/Dropdown";
import Accordion from "react-bootstrap/Accordion";
import DropdownButton from "react-bootstrap/DropdownButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

export default function SuiviClientAccordion({
  handleShowUpdate,
  customerlog,
  content,
  log_date,
  author,
  deleteCustomerLog,
  setIdCustomerLog,
}) {
  const date = new Date(log_date);
  const options = {
    weekday: "short",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const localeDateString = date.toLocaleDateString("Fr-FR", options);

  return (
    <Accordion>
      <Accordion.Item eventKey="0" className="mb-4 w-100 m-auto">
        <div className="row w100 align-items-center">
          <div
            className={
              parseInt(localStorage.getItem("user_role")) !== 5 &&
              parseInt(localStorage.getItem("user_role")) !== 6
                ? "col-md-10"
                : "col-md-12"
            }
          >
            <Accordion.Header as="div" className="">
              <div className="row w100">
                <div className="col-10">
                  <div className="mr-2 text-start ">
                    <span className="accordion-title">{`${
                      localeDateString.charAt(0).toUpperCase() +
                      localeDateString.slice(1)
                    } - Par ${author} `}</span>
                  </div>
                </div>
              </div>
            </Accordion.Header>
          </div>
          {(parseInt(localStorage.getItem("user_role")) !== 5 &&
            parseInt(localStorage.getItem("user_role")) !== 6) && (
            <div className="col-2 text-end pt-2">
              <DropdownButton title={<MoreVertIcon />} className="hidden-arrow">
                <Dropdown.Item
                  onClick={() => {
                    handleShowUpdate(customerlog);
                  }}
                >
                  <EditOutlinedIcon className="grey" /> Modifier
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    setIdCustomerLog(customerlog.id);
                    deleteCustomerLog(customerlog.id);
                  }}
                >
                  <DeleteOutlinedIcon className="red" /> Supprimer
                </Dropdown.Item>
              </DropdownButton>
            </div>
          )}
        </div>
        <div className="container-fluid">
          <Accordion.Body className="bg-blue-page">
            <div className="row pt-0">
              <p className="col-md w-50 pb-5 have-border-top pt-3">{content}</p>
            </div>
          </Accordion.Body>
        </div>
      </Accordion.Item>
    </Accordion>
  );
}
